import {palette} from 'shared/src/styles/palette'

const Styles = {
    BoxIcon: {
        display: "flex",
        justifyContent:"flex-end",
        margin:1
    },
    column: {
        minWidth: '200px',
        textAlign: 'center',
        fontWeight: 600,
    },
    BoxActionButtons: {
        display: 'flex',
        justifyContent:'center',
        
    }
}

export default Styles;